{
  "30s": "30 seconds",
  "60s": "60 seconds",
  "5m": "5 minutes",
  "10m": "10 minutes",
  "30m": "30 minutes",
  "60m": "60 minutes",
  "3h": "3 hours",
  "6h": "6 hours",
  "12h": "12 hours",
  "24h": "24 hours",
  "3d": "3 days",
  "7d": "7 days",
  "2w": "2 weeks"
}
